/*jshint esversion: 6 */
const state = {

};

const mutations = {

};

const actions = { 
    writeLog(context,props) {
        //console.log('writing log')
        const db = props.vm.$firebase.firestore();
 
        const logEntry = {
          timeStamp: new Date(),
          userid: props.userid,
          username: props.username,
          message: props.message
        }
        db.collection('logs').add(logEntry).then( (docRef) => {
            console.log('writing log ' + docRef);
        })
        .catch(err => {
            console.log (err.message);
        
        });   
        
      }      
   
}; 
  
const getters = {
 
};

export default {
    state,
    mutations,
    actions,
    getters
}
   